import { useEffect, useRef } from "react";

interface ScriptProps extends React.ScriptHTMLAttributes<HTMLScriptElement> {
  id: string;
  strategy?: "afterInteractive" | "lazyOnload";
}

export default function ScriptLoader({
  id,
  src,
  children,
  async = true,
  defer = false,
  strategy = "afterInteractive",
  ...restProps
}: ScriptProps) {

  const extraPropsString = JSON.stringify(restProps);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (document.getElementById(id)) return;

    const loadScript = () => {
      const script = document.createElement("script");
      script.id = id;
      if (src) script.src = src;
      script.async = async;
      script.defer = defer;
      
      if (children) {
        script.innerHTML = typeof children === "string" ? children : "";
      }

      const parsedProps = JSON.parse(extraPropsString);
      Object.keys(parsedProps).forEach((key) => {
        script.setAttribute(key, parsedProps[key]);
      });

      document.head.appendChild(script);
    };

    if (strategy === "lazyOnload") {
      if (document.readyState === "complete") {
        loadScript();
      } else {
        window.addEventListener("load", loadScript);
        return () => window.removeEventListener("load", loadScript);
      }
    } else {
      loadScript();
    }

  }, [id, src, children, async, defer, strategy, extraPropsString]);

  return null;
}
